import React, {useState, useEffect} from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import backArrow from '../../assets/images/arrow.svg';
import CircularLoader from '../../utils/Loaders/CircularLoader';
import { Post } from '../../Api/ApiMethods.js';
import { 
    getSubscriptionPlansUrl
 } from '../../Routes/ApiRoutes';

export default function ShowSubscription() {
    const history = useHistory();
    const token = useSelector((state) => state.auth.isSignedIn);
    const {id} = useParams();
    const {pathname} = useLocation();
    const [loader, setLoader] = useState(false);
    var pq = pathname.split('/');
    const [plansList, setPlansList] = useState([]);

    useEffect(() => {
        fetchSubscriptionPlans()
    }, [])
    const fetchSubscriptionPlans = () => {
        setLoader(true);
        try {
            Post(getSubscriptionPlansUrl, token)
            .then(res => {
                if(res.status === 200){
                    setPlansList(res.data.rows);
                    setLoader(false);
                }
            })
            .catch(error => {
                console.log(error);
                setLoader(false);
            })
          }catch (error) {
            console.log(error);
            setLoader(false);
        }
    }
    
    return (
        <>
        {loader && <CircularLoader />}
            <section className="Added-vehicles-wrapper">
                <div className="container">
                    <div className="Added-vehicles">
                        <div className="row no-gutters">
                            <div className="col-md-12 col-sm-12 col-12 padding-rt">
                                <div className="generate">
                                    <h3><img className="mr-2" onClick={() => {
                                        history.push(`/booking/vehicleList/${pq[pq.length-2]}`);
                                    }} src={backArrow} />Subscription plans</h3>
                                </div>
                            </div>
                            <div className="row no-gutters">
                                {plansList.length > 0 ? plansList.map((item) => {
                                    return(
                                    <div className="Subscription-plans">
                                        <div key={item.id} onClick={() => {
                                            history.push({
                                                pathname: `/booking/listCards/${pq[pq.length-2]}/${id}/${item.id}`
                                        })
                                    }} className="plans-info">
                                            <p>Term <span>{item.plan_recurring_interval}</span></p>
                                            <p>Charges per month <span> $ {item.plan_price}</span></p>
                                            <div className="Total-Charge">
                                                <p>Total Charge <span>$ {item.plan_price}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                )}) :
                                <div className="col-12 padding-rt">
                                    <div style={{textAlign:'center', padding:'200px 0'}}>
                                        <p>No subscription plan available!</p>
                                        <p>Please contact admin!</p>
                                    </div>
                                </div>
                            }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
